/** Participant copy for A1 and A2 (screens §A1; content §2.1 owns the welcome). */
import type { AssessmentPhase } from "@bsim/contracts";

export const CHECK_COPY: Readonly<Record<AssessmentPhase, { readonly title: string; readonly intro: string }>> = {
  pre: { title: "Your private baseline.", intro: "Ten short situations. No trick questions, no score shown. It helps us tailor your feedback." },
  post: { title: "Where you are now.", intro: "The same kind of short situations, about a different bank. No trick questions, no score shown. It helps us tailor your feedback." },
};
export const DONE_COPY = "Thanks. Your answers are private.";
export const FEEDBACK_HELD = "Your facilitator will release feedback after the debrief.";
/** A solo run has no facilitator: the same wait, said without one. */
export const FEEDBACK_HELD_SOLO = "Your feedback will appear here once it is ready.";
